'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundPage = function NotFoundPage() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h1',
      null,
      '404'
    ),
    _react2.default.createElement(
      'div',
      null,
      'Page Not Found'
    )
  );
};

exports.default = NotFoundPage;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/NotFoundPage.js
// module id = 1777
// module chunks = 0